/**
 * @file 落地页页面组件
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import { Button } from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import IconCardGroup from './components/icon-card/IconCardGroup';
import PictureTextCardGroup from './components/picture-text-card/PictureTextCardGroup';
import A from '../../components/a/A';
import TextCardGroup from '../../components/text-card/TextCardGroup';
import IconLinkCardGroup from './components/icon-link-card/IconLinkCardGroup';
import HorizontalPictureTextCardGroup
    from '../../components/hub-components/horizontal-picture-text-card/HorizontalPictureTextCardGroup';
import VerticalTabsList from '../../components/hub-components/vertical-tabs-list/VerticalTabsList';
import HorizontalTabsList from './components/horizontal-tabs-list/HorizontalTabsList';
import TextCardGroup2 from './components/text-card2/TextCards';
import PictureList from './components/picture-list/PictureList';

import usePaddleHooks from './paddleHooks';

import {
    IIconCardComponent,
    IIconLinkCardComponent,
    IPictureList,
    IPictureTextCardComponent,
    ITextCard2Component,
    ITextCardComponent
} from './types';

import { IVerticalTabsListCompoennt } from '../../components/hub-components/vertical-tabs-list/types';
import { IHorizontalPictureTextCardComponent } from '../../components/hub-components/horizontal-picture-text-card/types';
import PaddleXAi from '../paddle-x-ai/PaddleXAi';

const Paddle: React.FC = () => {
    const {
        bannerData,
        pageData
    } = usePaddleHooks();

    const pathname = window.location.pathname;

    /** 用户通过链接访问，则重定向至ai studio的paddlex页面 */
    if (pathname === '/paddle/paddleX') {
        window.location.href = 'https://aistudio.baidu.com/intro/paddlex';
        return <></>;
    }

    return (

        <div className="page paddle-paddle-page">
            <Header />

            {

                pathname === '/paddle/paddleX' ?

                     <PaddleXAi />
                    :
                    <>
                        {
                            !!bannerData
                            && (
                                <Banner
                                    title={bannerData.title}
                                    className="paddle-paddle-page-banner"
                                    subtitle={bannerData.subtitle}
                                    divider
                                >
                                    <div className="paddle-paddle-page-banner-btn-group">
                                        {bannerData.btns.map(item => (
                                            <A key={item.title} href={item.link} target={item.target ? '_blank' : ''}>
                                                <Button
                                                    className="paddle-paddle-page-banner-btn"
                                                    type="primary"
                                                    size="large"
                                                >
                                                    {item.title}
                                                </Button>
                                            </A>
                                        ))}
                                    </div>
                                </Banner>
                            )
                        }

                        <div className="paddle-paddle-page-container">
                            {pageData.map((component, index) => {
                                if (component.name === 'paddleIconCard') {
                                    const options: IIconCardComponent = component.options;
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                !!options.title
                                                && <div className="paddle-paddle-page-h2">
                                                    {options.title}
                                                </div>
                                            }
                                            {
                                                !!options.subtitle
                                                && <div className="paddle-paddle-page-h3">
                                                    {options.subtitle}
                                                </div>
                                            }
                                            {
                                                !!options.cardList && options.cardList.length > 0
                                                && <div className="paddle-paddle-page-context">
                                                    <IconCardGroup
                                                        cardList={options.cardList}
                                                    />
                                                </div>
                                            }
                                        </React.Fragment>
                                    );
                                }
                                if (component.name === 'paddlePictureTextCard') {
                                    const options: IPictureTextCardComponent = component.options;
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                !!options.title
                                                && <div className="paddle-paddle-page-h2">
                                                    {options.title}
                                                </div>
                                            }
                                            {
                                                !!options.subtitle
                                                && <div className="paddle-paddle-page-h3">
                                                    {options.subtitle}
                                                </div>
                                            }
                                            <div className="paddle-paddle-page-context">
                                                <PictureTextCardGroup
                                                    list={options.list}
                                                />
                                            </div>
                                        </React.Fragment>
                                    );
                                }
                                if (component.name === 'paddlePictureList') {
                                    const options: IPictureList = component.options;
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                !!options.title
                                                && <div className="paddle-paddle-page-h2">
                                                    {options.title}
                                                </div>
                                            }
                                            {
                                                !!options.subtitle
                                                && <div className="paddle-paddle-page-h3">
                                                    {options.subtitle}
                                                </div>
                                            }
                                            <PictureList
                                                {...options}
                                            />
                                        </React.Fragment>
                                    );
                                }
                                if (component.name === 'paddleTextCard') {
                                    const options: ITextCardComponent = component.options;
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                !!options.title
                                                && <div className="paddle-paddle-page-h2">
                                                    {options.title}
                                                </div>
                                            }
                                            {
                                                !!options.subtitle
                                                && <div className="paddle-paddle-page-h3">
                                                    {options.subtitle}
                                                </div>
                                            }
                                            <div className="paddle-paddle-page-context">
                                                <TextCardGroup option={options.cardList} />
                                            </div>
                                        </React.Fragment>
                                    );
                                }
                                if (component.name === 'paddleIconLinkCard') {
                                    const options: IIconLinkCardComponent = component.options;
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                !!options.title
                                                && <div className="paddle-paddle-page-h2">
                                                    {options.title}
                                                </div>
                                            }
                                            {
                                                !!options.subtitle
                                                && <div className="paddle-paddle-page-h3">
                                                    {options.subtitle}
                                                </div>
                                            }
                                            <div className="paddle-paddle-page-context">
                                                <IconLinkCardGroup cardList={options.cardList} />
                                            </div>
                                        </React.Fragment>
                                    );
                                }
                                if (component.name === 'paddleHorizontalPictureTextCard') {
                                    const options: IHorizontalPictureTextCardComponent = component.options;
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                !!options.title
                                                && <div className="paddle-paddle-page-h2">
                                                    {options.title}
                                                </div>
                                            }
                                            {
                                                !!options.subtitle
                                                && <div className="paddle-paddle-page-h3">
                                                    {options.subtitle}
                                                </div>
                                            }
                                            <div className="paddle-paddle-page-context">
                                                <HorizontalPictureTextCardGroup
                                                    list={options.list}
                                                />
                                            </div>
                                        </React.Fragment>
                                    );
                                }
                                if (component.name === 'paddleVerticalTabsList') {
                                    const options: IVerticalTabsListCompoennt = component.options;
                                    const group = Array.isArray(options.group) ? options.group : [];
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                !!options.title
                                                && <div className="paddle-paddle-page-h2">
                                                    {options.title}
                                                </div>
                                            }
                                            {
                                                !!options.subtitle
                                                && <div className="paddle-paddle-page-h3">
                                                    {options.subtitle}
                                                </div>
                                            }
                                            <div className="paddle-paddle-page-context">
                                                <VerticalTabsList
                                                    group={group}
                                                />
                                            </div>
                                        </React.Fragment>
                                    );
                                }
                                if (component.name === 'paddleHorizontalTabsList') {
                                    const options: IVerticalTabsListCompoennt = component.options;
                                    const group = Array.isArray(options.group) ? options.group : [];
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                !!options.title
                                                && <div className="paddle-paddle-page-h2">
                                                    {options.title}
                                                </div>
                                            }
                                            {
                                                !!options.subtitle
                                                && <div className="paddle-paddle-page-h3">
                                                    {options.subtitle}
                                                </div>
                                            }
                                            <div className="paddle-paddle-page-context">
                                                <HorizontalTabsList
                                                    group={group}
                                                />
                                            </div>
                                        </React.Fragment>
                                    );
                                }
                                if (component.name === 'paddleTextCard2') {
                                    const options: ITextCard2Component = component.options;
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                !!options.title
                                                && <div className="paddle-paddle-page-h2">
                                                    {options.title}
                                                </div>
                                            }
                                            {
                                                !!options.subtitle
                                                && <div className="paddle-paddle-page-h3">
                                                    {options.subtitle}
                                                </div>
                                            }
                                            <div className="paddle-paddle-page-context">
                                                <TextCardGroup2 {...options} />
                                            </div>
                                        </React.Fragment>
                                    );
                                }
                                return null;
                            })}
                        </div>
                    </>
            }

            <Footer />
        </div>
    );
};

export default Paddle;
